export const TEST_PARTICIPANT_RESULT_PATH =
  "/tests/:id/participants/:participantId";
